import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

export const PUBLIC_WEB_URL = (
  process.env.REACT_APP_PUBLIC_WEB_URL || 'https://app.skipdq.me'
).replace(/\/+$/, '');

export const LEGAL_DOCUMENTS = {
  privacy: { label: 'Privacy Policy', route: '/privacy-policy', pdfPath: '/privacy-policy.pdf' },
  terms: { label: 'Terms of Service', route: '/terms', pdfPath: '/terms-of-service.pdf' },
};

// Dev-only escape hatch so native-only UI can be exercised in a desktop browser via ?native=1.
export function isNativeApp() {
  if (Capacitor.isNativePlatform()) return true;
  if (process.env.NODE_ENV !== 'production' || window.location.hostname === 'localhost') {
    return new URLSearchParams(window.location.search).get('native') === '1';
  }
  return false;
}

export async function openExternalUrl(url) {
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url, presentationStyle: 'popover' });
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}

export function legalPdfUrl(kind) {
  const doc = LEGAL_DOCUMENTS[kind];
  return doc ? `${PUBLIC_WEB_URL}${doc.pdfPath}` : PUBLIC_WEB_URL;
}

export function openLegalDocument(kind) {
  return openExternalUrl(legalPdfUrl(kind));
}
